
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workerscompensationrates",
      function () {
        return require("private-next-pages/workerscompensationrates/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workerscompensationrates"])
      });
    }
  